import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';


@Injectable()
export class OrderProvider {

  orderSubject = new BehaviorSubject<string>(null);
  currentOrder = this.orderSubject.asObservable();

  constructor(private storage: Storage) {
  }

  setSelectedOrder(selectedOrder){
    this.orderSubject.next(selectedOrder);
    this.storage.set("selectedOrder", selectedOrder);
  }

  getSelectedOrder(){
    return this.storage.get("selectedOrder");
  }
}



// WEBPACK FOOTER //
// ./src/providers/order/order.ts